import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Storage from '@/utils/Storage'
// import { IS_BETA } from '@/utils/BetaFlag/betaFlag.js'
const FolderSettings = () => import('@/views/Domain/index.vue')
const Login = () => import('@/views/Login/index.vue')
const SignUp = () => import('@/views/SignUp/index.vue')
const Videos = () => import('@/views/Videos/index.vue')
const VideoPage = () => import('@/views/VideoPage/index.vue')
const Trash = () => import('@/views/Trash/index.vue')
const Playlists = () => import('@/views/Videos/Playlists/index.vue')
const PlaylistPage = () => import('@/views/PlaylistPage/index.vue')
const LiveV2 = () => import('@/views/LiveV2/index.vue')
const Analytics = () => import('@/views/Analytics/index.vue')
const DRM = () => import('@/views/DRM/index.vue')
const DRMInternal = () => import('@/views/DRM/indexIntern.vue')
const Management = () => import('@/views/Management/index.vue')

const Player = () => import('@/views/Player/index.vue')
const Settings = () => import('@/views/Settings/index.vue')
const Callback = () => import('@/views/CognitoLogin/index.vue')
const Upgrade = () => import('@/views/Upgrade/index.vue')
const Checkout = () => import('@/views/Checkout/index.vue')
const UserPlan = () => import('@/views/Settings/UserPlan/index.vue')
const MemberGetMember = () => import('@/views/MemberGetMember/index.vue')
const Credits = () => import('@/views/Settings/Credits/index.vue')
const Organization = () => import('@/views/Settings/Organization/index.vue')
const Quality = () => import('@/views/Settings/Quality/index.vue')
const Advanced = () => import('@/views/Settings/Advanced/index.vue')
const FirstLoading = () => import('@/views/FirstLoading/index.vue')
const NewLiveV2 = () => import('@/views/LiveV2/NewLiveV2.vue')
const Integrations = () => import('@/views/Settings/Integrations/index.vue')
const Cart = () => import('@/views/Cart/Cart.vue')
const AnalyticsV2 = () => import('@/views/AnalyticsV2/index.vue')
const AnalyticsV3 = () => import('@/views/AnalyticsV3/index.vue')
const AbTest = () => import('@/views/AbTest/index/index.vue')
const PandaAssist = () => import('@/views/PandaAssist/index.vue')
const Agent = () => import('@/views/PandaAssist/Agent/index.vue')
const NewTest = () => import('@/views/AbTest/NewTest/NewTest.vue')
const Webhooks = () => import('@/views/Settings/Webhooks/index.vue')
const AnalyticsRealtime = () => import('@/views/AnalyticsV2/Realtime.vue')
const MyAccount = () => import('@/views/Settings/MyAccount/index.vue')
const AntiDownload = () => import('@/views/AntiDownload/index.vue')
const Welcome = () => import('@/views/Welcome/index.vue')
const Funnel = () => import('@/views/Funnel/index.vue')
const FunnelPage = () => import('@/views/Funnel/Editor/index.vue')
const BaseComponentsTestPage = () =>
  import('@/views/BaseComponentsTestPage/index.vue')
const ShortlyPandaAssistAI = () =>
  import('@/views/PandaAssist/ShortlyPandaAssistAI/index.vue')

Vue.use(VueRouter)

/* eslint-disable no-unused-vars */
/* eslint-disable no-unreachable */
/* eslint-disable vue/no-unused-components */

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback,
  },
  {
    path: '/videos',
    name: 'Videos',
    component: Videos,
    meta: { hasAuth: true },
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome,
    meta: { hasAuth: true },
  },
  {
    path: '/videos/:id',
    name: 'VideoPage',
    component: VideoPage,
    meta: { hasAuth: true },
  },
  {
    path: '/video/trash',
    name: 'Trash',
    component: Trash,
    meta: { hasAuth: true },
  },
  {
    path: '/videos/:id/quiz-cta/:quizId',
    name: 'VideoPageQuizCta',
    component: VideoPage,
    meta: { hasAuth: true },
  },
  {
    path: '/videos/:id/quiz-cta',
    name: 'VideoPageQuizCtas',
    component: VideoPage,
    meta: { hasAuth: true },
  },
  {
    path: '/videos/:id/form-cta/:formId',
    name: 'VideoPageForm',
    component: VideoPage,
    meta: { hasAuth: true },
  },
  {
    path: '/videos/:id/button-interaction/:btnId',
    name: 'VideoPageButtonInteraction',
    component: VideoPage,
    meta: { hasAuth: true },
  },
  {
    path: '/video/playlists',
    name: 'Playlists',
    component: Playlists,
    meta: { hasAuth: true },
  },
  {
    path: '/playlist/:id',
    name: 'PlaylistPage',
    component: PlaylistPage,
    meta: { hasAuth: true },
  },
  {
    path: '/folders/:id',
    name: 'Folders',
    component: Videos,
    meta: { hasAuth: true },
  },
  {
    path: '/lives',
    name: 'LiveV2',
    component: LiveV2,
    meta: { hasAuth: true },
  },
  {
    path: '/lives/:id',
    name: 'NewLiveV2',
    component: NewLiveV2,
    meta: { hasAuth: true },
  },
  {
    path: '/lives/:id',
    name: 'NewLiveV2Edit',
    component: NewLiveV2,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsOld',
    name: 'Analytics',
    component: Analytics,
    meta: { hasAuth: true },
  },
  {
    path: '/analytics',
    name: 'AnalyticsV2',
    component: AnalyticsV2,
    meta: { hasAuth: true },
  },
  {
    path: '/analytics/account',
    name: 'AnalyticsV2Account',
    component: AnalyticsV2,
    meta: { hasAuth: true },
  },
  {
    path: '/analytics/retention',
    name: 'AnalyticsV2Retention',
    component: AnalyticsV2,
    meta: { hasAuth: true },
  },
  {
    path: '/analytics/locale',
    name: 'AnalyticsV2Locale',
    component: AnalyticsV2,
    meta: { hasAuth: true },
  },
  {
    path: '/analytics/devices',
    name: 'AnalyticsV2Devices',
    component: AnalyticsV2,
    meta: { hasAuth: true },
  },
  {
    path: '/analytics/browsers',
    name: 'AnalyticsV2Browsers',
    component: AnalyticsV2,
    meta: { hasAuth: true },
  },
  {
    path: '/analytics/references',
    name: 'AnalyticsV2References',
    component: AnalyticsV2,
    meta: { hasAuth: true },
  },
  {
    path: '/analytics/realtime',
    name: 'AnalyticsV2Realtime',
    component: AnalyticsRealtime,
    meta: { hasAuth: true },
  },
  {
    path: '/analytics/plays',
    name: 'AnalyticsV2Play',
    component: AnalyticsV2,
    meta: { hasAuth: true },
  },
  {
    path: '/analytics/bandwidth',
    name: 'AnalyticsV2Bandwidth',
    component: AnalyticsV2,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3',
    name: 'AnalyticsV3',
    component: AnalyticsV3,
    meta: { hasAuth: true },
    redirect: { name: 'AnalyticsV3Resume' },
  },
  {
    path: '/analyticsv3/resume',
    name: 'AnalyticsV3Resume',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/plays',
    name: 'AnalyticsV3Plays',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/retention',
    name: 'AnalyticsV3Retention',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/devices',
    name: 'AnalyticsV3Devices',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/browsers',
    name: 'AnalyticsV3Browsers',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/locations',
    name: 'AnalyticsV3Locations',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/reference',
    name: 'AnalyticsV3Reference',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/utm',
    name: 'AnalyticsV3UTM',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/lives',
    name: 'AnalyticsV3Lives',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/best-times',
    name: 'AnalyticsV3BestTimes',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/users',
    name: 'AnalyticsV3Users',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/bandwidth',
    name: 'AnalyticsV3Bandwidth',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/analyticsv3/videoComparer',
    name: 'AnalyticsV3VideoComparer',
    component: AnalyticsV3,
    meta: { hasAuth: true },
  },
  {
    path: '/security',
    name: 'DRM',
    component: DRM,
    meta: { hasAuth: true },
  },
  {
    path: '/domains',
    name: 'Domains',
    component: FolderSettings,
    meta: { hasAuth: true },
  },
  {
    path: '/security/:id',
    name: 'DRMGroup',
    component: DRMInternal,
    meta: { hasAuth: true },
  },
  {
    path: '/security/:id/keys',
    name: 'DRMGroupKeys',
    component: DRM,
    meta: { hasAuth: true },
  },
  {
    path: '/player',
    name: 'Player',
    component: Player,
    meta: { hasAuth: true },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { hasAuth: true },
  },
  {
    path: '/settings/management',
    name: 'Management',
    component: Management,
    meta: { hasAuth: true },
  },
  {
    path: '/settings/organization',
    name: 'Organization',
    component: Organization,
    meta: { hasAuth: true },
  },
  {
    path: '/settings/integrations',
    name: 'Integrations',
    component: Integrations,
    meta: { hasAuth: true },
  },
  {
    path: '/settings/account',
    name: 'Account',
    component: MyAccount,
  },
  {
    path: '/settings/plan',
    name: 'UserPlan',
    component: UserPlan,
    meta: { hasAuth: true },
  },
  {
    path: '/member-get-member',
    name: 'MemberGetMember',
    component: MemberGetMember,
    meta: { hasAuth: true },
  },
  {
    path: '/funnel',
    name: 'Funnel',
    component: Funnel,
    meta: { hasAuth: true },
  },
  {
    path: '/funnel/:id',
    name: 'FunnelPage',
    component: FunnelPage,
    meta: { hasAuth: true },
  },
  {
    path: '/settings/credits',
    name: 'Credits',
    component: Credits,
    meta: { hasAuth: true },
  },
  {
    path: '/settings/advanced',
    name: 'Advanced',
    component: Advanced,
    meta: { hasAuth: true },
  },
  {
    path: '/settings/quality',
    name: 'Quality',
    component: Quality,
    meta: { hasAuth: true },
  },
  {
    path: '/settings/webhooks',
    name: 'Webhooks',
    component: Webhooks,
    meta: { hasAuth: true },
  },
  {
    path: '/upgrade',
    name: 'Upgrade',
    component: Upgrade,
    meta: { hasAuth: true },
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: { hasAuth: true },
  },
  {
    path: '/checkout/:plan',
    name: 'Checkout',
    component: Checkout,
    meta: { hasAuth: true },
  },
  {
    path: '/firstLoading',
    name: 'FirstLoading',
    component: FirstLoading,
    meta: { hasAuth: true },
  },
  {
    path: '/anti-download',
    name: 'AntiDownload',
    component: AntiDownload,
    meta: { hasAuth: true },
  },
  {
    path: '/comparison',
    name: 'AbTest',
    component: AbTest,
    meta: { hasAuth: true },
  },
  // PandaAssist
  {
    path: '/tutor',
    name: 'Tutor',
    component: PandaAssist,
    meta: { hasAuth: true },
  },
  {
    path: '/shortly-tutor',
    name: 'ShortlyTutor',
    component: ShortlyPandaAssistAI,
    meta: { hasAuth: true },
  },
  {
    path: '/tutor/:id',
    name: 'AgentPage',
    component: Agent,
    meta: { hasAuth: true },
  },
  {
    path: '/comparison/:id',
    name: 'NewTest',
    component: NewTest,
    meta: { hasAuth: true },
  },
  {
    path: '/baseComponents',
    name: 'BaseComponentsTestPage',
    component: BaseComponentsTestPage,
    meta: { hasAuth: true },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'Login' },
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  const { getters: storeGetters } = await store()
  const canSeePlanInfo = storeGetters['user/canSeePlanInfo']
  console.debug(to, canSeePlanInfo)
  const planInfoRoutes = ['UserPlan', 'Cart']
  let redirect = (from.query.redirect || to.query.redirect) ?? false
  Storage.removeItem('activeTab')
  try {
    redirect = redirect ? decodeURIComponent(redirect) : redirect
  } catch (err) {
    console.error(err)
    redirect = false
  }

  let session = false

  try {
    session = !!(await store().dispatch('session/fetchSession'))
  } catch (error) {
    /* console.log(error); */
  }
  if (localStorage.getItem('firstAccess') && to.name !== 'Welcome') {
    next({ name: 'Welcome' })
  }
  if (session && redirect && !to.fullPath.includes(redirect))
    return next(redirect)
  if (to.matched.some((record) => record.meta.hasAuth)) {
    if (!session) {
      next({ name: 'Login' })
    } else {
      if (to.name === 'Login' || to.name === null) {
        next({ name: 'Videos' })
      }
      if (
        to.name === 'BaseComponentsTestPage' &&
        (location.host === 'dashboard.pandavideo.com.br' ||
          location.host === 'dashboard.pandavideo.com')
      ) {
        next({ name: 'Videos' })
      }
    }
  } else {
    if (to.name === 'Login' || to.name === null) {
      if (session) {
        next({ name: 'Videos' })
      } else {
        next()
      }
    }
    next()
  }

  next()
})

export default router
